module.exports = __webpack_public_path__ + "img/H000090_fishhead.74a739cb.png";